import  { Component } from "react";
import { AddSwipeUp } from "@/utils/GlobalJavascriptFunction";
import stl from "./Story.module.css";
class Story extends Component {
  constructor(props) {
    super(props);
    this.myTimeout = undefined;

    this.state = {
      stories:
        this?.props?.children && this?.props?.children.length > 1
          ? this?.props?.children
          : [this?.props?.children],
      activeBGColor: "#7cc8d6",
      activeStoryIndex: this.props.activeStory || 0,
      animateCloseMobile: false,
    };
  }

  componentDidMount() {
    this.setActiveBGColor();
    this.startTimer();
    AddSwipeUp(document.querySelector("body"), this.closeStoryMode);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this?.props?.children !== prevProps?.children) {
      this.setState({
        stories:
          this?.props?.children.length > 1
            ? this?.props?.children
            : [this?.props?.children],
      });
      this.setActiveBGColor();
    }
  }

  startTimer = () => {
    this.myTimeout = setTimeout(() => {
      this.setNewStory(this.state.activeStoryIndex + 1);
    }, 12000);
  };

  setNewStory = (newIndex) => {
    if (newIndex > this.state.stories.length - 1) {
      this.setState(
        {
          activeStoryIndex: 0,
        },
        () => {
          this.setActiveBGColor();
          this.closeStoryMode();
        }
      );
    } else {
      clearTimeout(this.myTimeout);
      this.setState(
        {
          activeStoryIndex:
            newIndex <= this.state.stories.length - 1
              ? newIndex < 0
                ? this.state.stories.length - 1
                : newIndex
              : 0,
        },
        () => {
          this.setActiveBGColor();
          this.startTimer();
        }
      );
    }
  };

  setActiveBGColor = () => {
    this.setState({ activeBGColor: this.props.BGColor });
  };

  closeStoryMode = () => {
    if (this.props.showStoryMode) {
      clearTimeout(this.myTimeout);
      document.querySelector("body").style.overflow = "hidden";
      this.setState({ animateCloseMobile: true }, () => {
        setTimeout(() => {
          this.setState({
            animateCloseMobile: false,
          });
          document.querySelector("body").style.overflow = "";
          this.props.closeStory();
        }, 200);
      });
    }
  };

  render() {
    return (
      this.props.showStoryMode && (
        <>
          <div
            className={[
              stl.stryContainer,
              stl.openStry,
              this.state.animateCloseMobile
                ? stl.animateCloseMobile
                : undefined,
            ].join(" ")}
            onClick={(e) =>
              e.target === e.currentTarget && this.closeStoryMode()
            }>
            <div className={stl.strysubContainer}>
              <span
                className={stl.clsStry}
                onClick={() => this.closeStoryMode()}></span>
              <span
                className={stl.rsst}
                onClick={() =>
                  this.setNewStory(this.state.activeStoryIndex - 1)
                }></span>
              <span
                className={stl.lsst}
                onClick={() =>
                  this.setNewStory(this.state.activeStoryIndex + 1)
                }></span>
              <div
                className={stl.allstry}
                data-strycount="0"
                style={{
                  background: this.state.activeBGColor,
                }}>
                {this.state.stories[this.state.activeStoryIndex]}

                {this.state.stories.length > 0 && (
                  <>
                    <div className={stl.allstryLine}>
                      {this.state.stories.map((story, i) => {
                        return (
                          <span
                            key={"stry" + i}
                            style={{
                              width:
                                "calc(100% / " +
                                this.state.stories.length +
                                " - 5px)",
                            }}
                            className={
                              i > this.state.activeStoryIndex
                                ? ""
                                : i == this.state.activeStoryIndex
                                ? stl.inview
                                : stl.doneView
                            }></span>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )
    );
  }
}

export default Story;
